const getMREnable = (): boolean => {
  const isMREnable = JSON.parse(sessionStorage.getItem('api_url')!)?.MR_ENABLE;

  return Boolean(isMREnable);
};

const getITReqEnable = (): boolean => {
  const isITReqEnable = JSON.parse(
    sessionStorage.getItem('api_url')!
  )?.IT_REQ_ENABLE;

  return Boolean(isITReqEnable);
};

const getResignationEnable = (): boolean => {
  const isResignationEnable = JSON.parse(
    sessionStorage.getItem('api_url')!
  )?.RESIGNATION_ENABLE;

  return Boolean(isResignationEnable);
};

const getContactPageEnable = (): boolean => {
  const isContactPageEnable = JSON.parse(
    sessionStorage.getItem('api_url')!
  )?.CONTACT_PAGE_ENABLE;

  return Boolean(isContactPageEnable);
};

const getRaiseRequestMenuEnable = (): boolean => {
  const isRaiseRequestMenuEnable = JSON.parse(
    sessionStorage.getItem('api_url')!
  )?.RAISE_REQUEST_MENU_ENABLE;

  return Boolean(isRaiseRequestMenuEnable);
};

const getReportIssueMenuEnable = (): boolean => {
  const isReportIssueMenuEnable = JSON.parse(
    sessionStorage.getItem('api_url')!
  )?.REPORT_ISSUE_MENU_ENABLE;

  return Boolean(isReportIssueMenuEnable);
};

export {
  getContactPageEnable,
  getITReqEnable,
  getMREnable,
  getRaiseRequestMenuEnable,
  getReportIssueMenuEnable,
  getResignationEnable,
};
